import { createFileRoute } from "@tanstack/react-router";

import LeagueOverview from "@/components/LeagueOverview/LeagueOverview";

const Component = () => {
  const { leagueUuid } = Route.useParams();
  return <LeagueOverview leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid")({
  component: Component,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/events",
      },
    };
  },
});
